var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Icon from '@ant-design/icons';
var AvatarSVG = function () { return (React.createElement("svg", { width: '32', height: '32', viewBox: '0 0 40 40', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("circle", { cx: '20', cy: '20', r: '20', fill: '#E5F2FF' }),
    React.createElement("mask", { id: 'mask0', style: { maskType: 'alpha' }, maskUnits: 'userSpaceOnUse', x: '0', y: '0', width: '40', height: '40' },
        React.createElement("circle", { cx: '20', cy: '20', r: '20', fill: '#E6F7FF' })),
    React.createElement("g", { mask: 'url(#mask0)' },
        React.createElement("path", { opacity: '0.4', d: 'M19.9992 25.3236C24.0263 25.3236 27.2909 22.059 27.2909 18.0319C27.2909 14.0048 24.0263 10.7402 19.9992 10.7402C15.9721 10.7402 12.7075 14.0048 12.7075 18.0319C12.7075 22.059 15.9721 25.3236 19.9992 25.3236Z', fill: '#1890FF' }),
        React.createElement("path", { d: 'M19.9994 28.9688C12.6932 28.9688 6.74316 33.8688 6.74316 39.9063C6.74316 40.3146 7.064 40.6354 7.47233 40.6354H32.5265C32.9348 40.6354 33.2557 40.3146 33.2557 39.9063C33.2557 33.8688 27.3057 28.9688 19.9994 28.9688Z', fill: '#1890FF' })))); };
//TODO type
export var AvatarOutlined = function (props) { return (React.createElement(Icon, __assign({ component: AvatarSVG }, props))); };
//# sourceMappingURL=AvatarOutlined.js.map